import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faXTwitter } from "@fortawesome/free-brands-svg-icons/faXTwitter";
import { faFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF";
import { faLinkedinIn } from "@fortawesome/free-brands-svg-icons/faLinkedinIn";
import "../CSS/Footer.css";

// Icon social links
const socialLinks = [
    { label: "Instagram", icon: faInstagram, url: "https://www.instagram.com/krmuniv/" },
    { label: "X (Twitter)", icon: faXTwitter, url: "https://x.com/krmuniversity" },
    { label: "Facebook", icon: faFacebookF, url: "https://facebook.com/krmuniv" },
    { label: "LinkedIn", icon: faLinkedinIn, url: "https://www.linkedin.com/school/krmuniv/" },
];

const Footer = React.memo(() => {
    // Top par smooth scroll karne ke liye helper function
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    // Contact Section par smooth scroll karne ke liye function
    const scrollToContact = () => {
        setTimeout(() => {
            const el = document.getElementById('contact-heading');
            if (el) {
                el.scrollIntoView({ behavior: 'smooth' });
            } else {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }, 150);
    };

    return (
        <footer className="footer">
            <div className="footer-main">
                {/* LEFT: Logo Box + Journal Info + Contact */}
                <div className="footer-left">
                    <div className="footer-journal-section">
                        <div className="footer-logo-combination">
                            <picture>
                                <source srcSet="/itme-logo-104.webp" type="image/webp" />
                                <img src="/itme-logo-104.png" alt="ITME Logo" className="footer-logo-itme" width="104" height="104" loading="lazy" decoding="async" />
                            </picture>
                            <span className="footer-logo-separator">×</span>
                            <picture>
                                <source srcSet="/krmu-104.webp" type="image/webp" />
                                <img src="/krmu-104.png" alt="K.R. Mangalam University Logo" className="footer-logo-krmu" width="104" height="104" loading="lazy" decoding="async" />
                            </picture>
                        </div>
                        <div className="footer-journal-text">
                            <p style={{ fontWeight: 'bold', fontSize: '0.95rem', margin: '0 0 2px' }}>
                                Innovative Trends in Multidisciplinary Engineering
                            </p>
                            <p className="footer-publisher">Published by K.R. Mangalam University</p>
                        </div>
                    </div>
                    <div className="footer-contact-section">
                        <h4 className="footer-section-title">Contact Information</h4>
                        <div className="footer-contact-list">
                            <div className="footer-contact-item">
                                <span className="footer-contact-label">Address:</span>
                                <span className="footer-contact-text">K.R. Mangalam University, Sohna Road, Gurugram, Haryana 122103</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* RIGHT: Links + Social icons */}
                <div className="footer-right">
                    <div className="footer-links-section">
                        <div className="footer-links-group">
                            <h4>Quick Links</h4>
                            <Link to="/about" onClick={scrollToTop} className="footer-link">About Journal</Link>
                            <Link to="/editorial-leadership" onClick={scrollToTop} className="footer-link">Editorial Leadership</Link>
                            <Link to="/archives" onClick={scrollToTop} className="footer-link">Archives</Link>
                            <Link to="/current-issue" onClick={scrollToTop} className="footer-link">Current Issue</Link>
                            <Link to="/author-guidelines" onClick={scrollToTop} className="footer-link">Author Guidelines</Link>
                        </div>
                        <div className="footer-links-group">
                            <h4>Support</h4>
                            <Link to="/about" onClick={scrollToContact} className="footer-link">Contact Us</Link>
                            <a 
                                href="https://mail.google.com/mail/?view=cm&fs=1&to=support.itme@krmangalam.edu.in" 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                className="footer-link"
                            >
                                Technical Support
                            </a>
                            <a 
                                href="https://mail.google.com/mail/?view=cm&fs=1&to=editor.itme@krmangalam.edu.in" 
                                target="_blank" 
                                rel="noopener noreferrer" 
                                className="footer-link"
                            >
                                Editorial Office
                            </a>
                        </div>
                        <div className="footer-links-group">
                            <h4>Policy & Ethics</h4>
                            <Link to="/privacy-policy" onClick={scrollToTop} className="footer-link">Privacy Policy</Link>
                            <Link to="/terms-and-conditions" onClick={scrollToTop} className="footer-link">Terms & Conditions</Link>
                            <Link to="/ethics" onClick={scrollToTop} className="footer-link">Ethics</Link>
                            <Link to="/itme-policies-framework" onClick={scrollToTop} className="footer-link">ITME Policies Framework</Link>
                        </div>
                    </div>
                    <div className="footer-social-icons" aria-label="Social media links">
                        {socialLinks.map((s) => (
                            <a key={s.label} href={s.url} target="_blank" rel="noopener noreferrer" className="footer-social-icon" aria-label={s.label} title={s.label}>
                                <FontAwesomeIcon icon={s.icon} aria-hidden="true" />
                            </a>
                        ))}
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <p className="footer-copyright">© 2025 ITME Journal - K.R. Mangalam University. All rights reserved.</p>
                <p className="footer-issn">International Peer-Reviewed Journal - Open Access Publication</p>
            </div>
        </footer>
    );
});

export default Footer;
